import http from '@/api/request'

// 党史教育
export function shopHistoryList(data) {
    return http().post('/resource/api/shop/history/list', data)
}

// 操作指南
export function guideTreeData(params) {
    return http().get('/resource/auth/course/view/instruction/tree/data', { params })
}

// 操作指南详情
export function guideInfoPreview(data) {
    return http().post('/resource/auth/material/info/preview', data)
}
